const PAYMENT_BANNER_PREFIX = "payment_banner";

export const PAYMENT_BANNER_TEST_IDS = {
    IMAGE_CONTAINER: `${PAYMENT_BANNER_PREFIX}_image`,
    KYC_CONATINER: `${PAYMENT_BANNER_PREFIX}_kyc`,
};
